import httpHelper from "@/helpers/httpHelper";

const giftService = {
  async getGifts(data) {
    return await httpHelper.get("/WebApi/Gift/GetGifts", data);
  },
  async useGift(data, reCaptchaToken) {
    return await httpHelper.post("/WebApi/Gift/Use", data, {
      headers: {
        reCaptchaToken,
      },
    });
  },
};

export default giftService;
